module.exports = __webpack_public_path__ + "img/our-03.5869ccd5.png";